import { render, staticRenderFns } from "./compatibleVersion.vue?vue&type=template&id=64955df2&"
import script from "./compatibleVersion.vue?vue&type=script&lang=js&"
export * from "./compatibleVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64955df2')) {
      api.createRecord('64955df2', component.options)
    } else {
      api.reload('64955df2', component.options)
    }
    module.hot.accept("./compatibleVersion.vue?vue&type=template&id=64955df2&", function () {
      api.rerender('64955df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ota/compatibleVersion.vue"
export default component.exports